import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { RestService, Rest, ABP } from '@abp/ng.core';
import { AuthenticateResult } from '../models';
import { from, Observable, Subscription, timer } from 'rxjs';
import { OAuthStorage, OAuthService } from 'angular-oauth2-oidc';

@Injectable({
    providedIn: 'root',
})
export class TerminalAuthService {

    apiName = 'TerminalManagement';
    constructor(
        private _storage: OAuthStorage,
        private _authService: OAuthService,
        private restService: RestService
    ) { }

    refreshSubscription: Subscription;

    refreshToken(userToken: string, refreshToken: string) {
        const request: Rest.Request<any> = {
            method: 'POST',
            url: `/api/TerminalManagement/TokenAuth/refresh`,
            body: {
                userToken,
                refreshToken
            }
        };
        return this.restService.request<null, AuthenticateResult>(request, { apiName: this.apiName });
    }

    refreshInterval(userToken: string, refreshToken: string) {
        if (!!this.refreshSubscription) {
            this.refreshSubscription.unsubscribe();
        }

        this.refreshSubscription = timer(1000 * 59, 1000 * 59 * 10)
            .subscribe(() => {

                this.refreshToken(userToken, refreshToken).subscribe(response => {
                    if(!!response){
                        this.storeAccessTokenResponse(
                            response.accessToken,
                            response.refreshToken,
                            response.expiresIn,
                            response.grantedScopes,
                            null
                        );
    
                        this.refreshSubscription.unsubscribe();
                        this.refreshSubscription = undefined;
    
                        if (!!response.refreshToken) this.refreshInterval(userToken, response.refreshToken);
                    }
                    
                });
            });
    }

    loginWithUserToken(userToken: string, tenantId: string): Promise<boolean> {
        return new Promise<boolean>((reslove, reject) => {
            this.getLoginResultWithUserToken(userToken, tenantId)
                .subscribe(result => {
                    if (!!result) {
                        // 登录成功
                        this.storeAccessTokenResponse(
                            result.accessToken,
                            result.refreshToken,
                            result.expiresIn,
                            result.grantedScopes,
                            null
                        );

                        if (!!result.refreshToken) this.refreshInterval(userToken, result.refreshToken);

                        reslove(true);
                    } else {
                        reslove(false);
                    }
                }, () => reslove(false));
        });

    }

    getLoginResultWithUserToken(userToken: string, tenantId: string): Observable<AuthenticateResult> {
        const request: Rest.Request<null> = {
            method: 'POST',
            url: `/api/TerminalManagement/TokenAuth/login/${userToken}`,
            headers: new HttpHeaders({ __tenant: tenantId })
        };
        return this.restService.request<null, AuthenticateResult>(request, { apiName: this.apiName });
    }

    protected storeAccessTokenResponse(
        accessToken: string,
        refreshToken: string,
        expiresIn: number,
        grantedScopes: String,
        customParameters?: Map<string, string>
    ): void {
        this._storage.setItem('access_token', accessToken);
        if (grantedScopes && !Array.isArray(grantedScopes)) {
            this._storage.setItem(
                'granted_scopes',
                JSON.stringify(grantedScopes.split('+'))
            );
        } else if (grantedScopes && Array.isArray(grantedScopes)) {
            this._storage.setItem('granted_scopes', JSON.stringify(grantedScopes));
        }

        this._storage.setItem('access_token_stored_at', '' + Date.now());
        if (expiresIn) {
            const expiresInMilliSeconds = expiresIn * 1000;
            const now = new Date();
            const expiresAt = now.getTime() + expiresInMilliSeconds;
            this._storage.setItem('expires_at', '' + expiresAt);
        }

        if (refreshToken) {
            this._storage.setItem('refresh_token', refreshToken);
        }

        if (customParameters) {
            customParameters.forEach((value: string, key: string) => {
                this._storage.setItem(key, value);
            });
        }
    }
}
